module.exports = {
	"about": "about",
	"access": "access",
	"auction": "auction",
	"auctioneer": "auctioneer",
	"auctions": "auctions",
	"bids": "bids",
	"billing": "billing",
	"buying": "buying",
	"catalog": "catalog",
	"category": "category",
	"claim": "claim",
	"confirmemail": "confirmemail",
	"contact": "contact",
	"control": "control",
	"country": "country",
	"create": "create",
	"dashboard": "dashboard",
	"directory": "directory",
	"emails": "emails",
	"export": "export",
	"features": "features",
	"forgotpw": "forgotpw",
	"help": "help",
	"history": "history",
	"increments": "increments",
	"info": "info",
	"invoice": "invoice",
	"invoices": "invoices",
	"live": "live",
	"login": "login",
	"logo": "logo",
	"logout": "logout",
	"lot": "lot",
	"management": "management",
	"methods": "methods",
	"monitor": "monitor",
	"payment": "payment",
	"permissions": "permissions",
	"phone": "phone",
	"picture": "picture",
	"press": "press",
	"pricing": "pricing",
	"privacy": "privacy",
	"profile": "profile",
	"report": "report",
	"resetpw": "resetpw",
	"search": "search",
	"security": "security",
	"seller": "seller",
	"selleraccount": "selleraccount",
	"selleraccounts": "selleraccounts",
	"selling": "selling",
	"settings": "settings",
	"signup": "signup",
	"soon": "soon",
	"staff": "staff",
	"staffaccess": "staffaccess",
	"staffinvite": "staffinvite",
	"subscription": "subscription",
	"terminology": "terminology",
	"terms": "terms",
	"userlist": "userlist",
	"userlists": "userlists",
	"userlistrequests": "userlistrequests",
	"usermodel": "usermodel",
	"users": "users"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/routes.json5
// module id = 1957
// module chunks = 6